import { Suspense } from 'react';
import { CharacteristicGroupSelect } from './CharacteristicGroupSelect';
import { CharacteristicGroupSelectStub } from './CharacteristicGroupSelectStub';
import { type CharacteristicGroupSelectProps } from './types';

export const CharacteristicGroupSelectSuspense = (props: CharacteristicGroupSelectProps) => (
    <Suspense fallback={<CharacteristicGroupSelectStub />}>
        <CharacteristicGroupSelect {...props} />
    </Suspense>
);
